import React, { useMemo, useRef, useState } from "react";
import { queryBuilder } from '@lbs/swarm-client'; 
import Zergling from "../../../helpers/zergling";
import { useDataFetch } from "../../containers/customHooks/dataFetch";
import { connect } from "react-redux";
import { toggleEvent } from "../../../helpers/sport/betslip";
import { t } from "../../../helpers/translator";

const baseEventsSwarmRequest = (originalMarketType, eventType, gameId) => {
    const builder = queryBuilder()
        .useSource('betting')
        .selectGame([])
        .selectMarket([])
        .selectEvent(['id', 'order', 'name', 'price', 'type', 'base'])
        .whereMarket('market_type').is(originalMarketType)
        .whereEvent('type').is(eventType)
        .whereGame('id').is(gameId);

    return builder.getParams();
};

const BetslipBaseDropdown = ({ dispatch, bet: { gameId, eventType, sportType, marketId, isBoosted, eventId, marketOriginalType, ...rest } }) => {
    const [open, setOpen] = useState(false);

    const dropdownElementRef = useRef(null);

    const [data] = useDataFetch(() => Zergling.get(baseEventsSwarmRequest(marketOriginalType, eventType, gameId), "get"), [marketOriginalType, eventType, gameId]);

    const game = data && Object.values(data?.data?.game)[0];

    const event = useMemo(() => {
        if (!game) return {};

        return Object.values(game.market).reduce((acc, item) => {
            const eventInsideMarket = Object.values(item.event).find(events => events.type === eventType);
            const data = {...acc}
            
            if (eventInsideMarket)
                data[eventInsideMarket.id] = eventInsideMarket

            return data
        }, {});
    }, [game, eventType]);

    const selectedEvent = event[eventId];

    const onBaseChange = (e, game, item) => {
        eventId !== item.id && dispatch(toggleEvent(game, game.market[marketId], item, sportType, item.id, isBoosted))
        e.stopPropagation()
        setOpen(false);
    }

    const handleOutsideClick = () => !open && window.addEventListener('mousedown', outsideClickListener);

    const outsideClickListener = (e) => {
        if (dropdownElementRef.current?.contains(e.target)) return;

        setOpen(false);
        window.removeEventListener('mousedown', outsideClickListener);
    }

    return (
        <div>
            <div className={`dropdown-view-w-t baseChange ${open ? "active" : ""}`} ref={dropdownElementRef} onClick={() => {
                handleOutsideClick()
                setOpen(!open)
            }}>
                <p>{selectedEvent ? <>{t(selectedEvent.name)} {selectedEvent ? (selectedEvent.base > 0 ? `+${selectedEvent.base}` : selectedEvent.base) : ''}</> : ''}</p>
                <div className="open-d-w-t baseChange">
                    <ul>
                        {
                            Object.values(event).map(item => <li
                                className={item.id === eventId ? "active" : ""}
                                onClick={(e) => onBaseChange(e, game, item)}>{t(item?.name)} {item ? (item.base > 0 ? `+${item.base}` : item.base) : ''}</li>)
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

BetslipBaseDropdown.defaultProps = {
    sportType: "odd"
}
export default connect()(BetslipBaseDropdown);
